export default __webpack_public_path__ + "static/media/latest-news-img24.f5141fb8.jpg";